import { render, staticRenderFns } from "./User-information-card.vue?vue&type=template&id=3fd2d5ec&scoped=true"
import script from "./User-information-card.vue?vue&type=script&lang=js"
export * from "./User-information-card.vue?vue&type=script&lang=js"
import style0 from "./User-information-card.vue?vue&type=style&index=0&id=3fd2d5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2d5ec",
  null
  
)

export default component.exports